export enum AmlProviderType {
  Amlcrypto = 'amlcrypto',
}
